import axios from 'axios';
import { Market } from 'common/consts/markets';

export const getPaymentMethodName = (methodNames: any, paymentType: string) => {
  const isTranslationsExist =
    methodNames && methodNames.hasOwnProperty(paymentType);
  return isTranslationsExist ? methodNames[paymentType] : undefined;
};


export const getPaymentMethodsConfig = (Model: any, CurrentMarket? : string) => {
  if (!Model) return {};
  const translatedPaymentMethods =
    Model?.AdyenForm?.Translations?.paymentMethodsNames;   
  return {
    applepay: {
      name: getPaymentMethodName(translatedPaymentMethods, 'applepay'),
      amount: {
        value: Model?.AdyenForm?.PaymentAmount?.value,
        currency: Model?.AdyenForm?.PaymentAmount?.currency,
      },
      countryCode: Model.AdyenForm?.CountryCode,
      configuration: {
        merchantName: Model.AdyenForm?.ApplePayMerchantName,
        merchantId: Model.AdyenForm?.ApplePayMerchantIdentifier,
      },
      ...((CurrentMarket === Market.BE || CurrentMarket === Market.NL) && {merchantCapabilities:[`supports3DS`, `supportsDebit`]} ),      
      onValidateMerchant: async (
        resolve: any,
        reject: any,
        validationURL: any,
      ) => {
        axios
          .post('/applePay/verifyMerchant', validationURL, {
            headers: {
              dataType: 'json',
            },
          })
          .then((response) => resolve(response.data))
          .catch((error) => reject(error));
      },
      // onSubmit: function (state) {
      //     makePayment(state.data, dropin);
      // },
      buttonType: 'plain',
    },
    card: {
      name: getPaymentMethodName(translatedPaymentMethods, 'scheme'),
      hasHolderName: Model.AdyenForm?.ShowCardHolderName,
      holderNameRequired: Model.AdyenForm?.ShowCardHolderName,
      enableStoreDetails: Model.AdyenForm?.EnableStoreDetails,
      // onChange: function() {
      //     var $btn = $(".adyen-checkout__button");
      //     if($btn.isDisabled)
      //         $(".adyen-checkout__button").prop("disabled", false);
      // }
    },
    directEbanking: {
      name: getPaymentMethodName(translatedPaymentMethods, 'directEbanking'),
      countryCode: Model.AdyenForm?.CountryCode,
    },
    dotpay: {
      name: getPaymentMethodName(translatedPaymentMethods, 'dotpay'),
    },
    paywithgoogle: {
      name: getPaymentMethodName(translatedPaymentMethods, 'paywithgoogle'),
      environment: Model.AdyenForm?.GooglePayEnvironment,
      amount: {
        value: Model.AdyenForm?.PaymentAmount?.value,
        currency: Model.AdyenForm?.PaymentAmount?.currency,
      },
      configuration: {
        gatewayMerchantId: Model.AdyenForm?.GooglePayGatewayMerchantId,
        merchantId: Model.AdyenForm?.GooglePayMerchantIdentifier,
      },      
      // onSubmit: function(state) {
      //     makePayment(state.data, dropin);
      // },
      buttonType: 'short',
    },
    sepadirectdebit: {
      name: getPaymentMethodName(translatedPaymentMethods, 'sepadirectdebit'),
      // onChange: function () {
      //     if (showConfirmMessage == true) {
      //         var ckbox = $('#ChkConfirmMessage');
      //         if (ckbox.is(':checked')) {
      //             $(".adyen-checkout__payment-method--sepadirectdebit .adyen-checkout__button").prop("disabled", false);
      //         }
      //         else {
      //             $(".adyen-checkout__payment-method--sepadirectdebit .adyen-checkout__button").prop("disabled", true);
      //         }
      //     }
      // }
    },
    bcmc: {
      hasHolderName: Model.AdyenForm?.ShowCardHolderName,
      holderNameRequired: Model.AdyenForm?.ShowCardHolderName,
      name: getPaymentMethodName(translatedPaymentMethods, 'bcmc'),
      // onChange: function () {
      //     if (showConfirmMessage == true) {
      //         var ckbox = $('#ChkConfirmMessage');
      //         if (ckbox.is(':checked')) {
      //             $(".adyen-checkout__payment-method--bcmc .adyen-checkout__button").prop("disabled", false);
      //         }
      //         else {
      //             $(".adyen-checkout__payment-method--bcmc .adyen-checkout__button").prop("disabled", true);
      //         }
      //     }
      // }
    },
    ideal: {
      // onChange: function () {
      //     if (showConfirmMessage == true) {
      //         var ckbox = $('#ChkConfirmMessage');
      //         if (ckbox.is(':checked')) {
      //             $(".adyen-checkout__payment-method--ideal .adyen-checkout__button").prop("disabled", false);
      //         }
      //         else {
      //             $(".adyen-checkout__payment-method--ideal .adyen-checkout__button").prop("disabled", true);
      //         }
      //     }
      // }
    },
  };
};

export const getPaymentConfig = (Model: any) => ({
  amount: {
    value: Model?.AdyenForm?.PaymentAmount?.Value,
    currency: Model?.AdyenForm?.PaymentAmount?.Currency,
  },
  paymentMethodsResponse: {
    paymentMethods: Model?.AdyenForm?.PaymentMethods,
  },
  clientKey: Model?.AdyenForm?.ClientKey,
  locale: Model?.AdyenForm?.Locale,
  environment: Model?.AdyenForm?.SdkMode,
});